module.exports = __webpack_public_path__ + "static/media/loading.378cbb75.gif";